import {RouteRecordRaw} from 'vue-router';
import {
    COST_REDUCTION_ANALYSIS,
    BUSINESS_TRIP_ANALYSIS,
    STATISTICS_ROUTE_INFO,
    BUSINESS_TRIP_ANALYSIS_PATH,
    COST_REDUCTION_ANALYSIS_PATH,
    BASE_PATH,
} from '@/types/statistics/constants';

const routes: RouteRecordRaw[] = [
    // 통계
    {
        path: BASE_PATH,
        redirect: {
            name: COST_REDUCTION_ANALYSIS,
        },
    },
    {
        path: COST_REDUCTION_ANALYSIS_PATH,
        name: COST_REDUCTION_ANALYSIS,
        meta: {
            title: STATISTICS_ROUTE_INFO[COST_REDUCTION_ANALYSIS].title,
        },
        components: {
            default: () =>
                import('@/views/statistics/CostReductionAnalysis.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
    {
        path: BUSINESS_TRIP_ANALYSIS_PATH,
        name: BUSINESS_TRIP_ANALYSIS,
        meta: {
            title: STATISTICS_ROUTE_INFO[BUSINESS_TRIP_ANALYSIS].title,
        },
        components: {
            default: () =>
                import('@/views/statistics/BusinessTripAnalysis.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
            SideBar: () => import('@/components/common/layout/SideBar.vue'),
        },
    },
];

export default routes;
